import BasePolicy from '@/policies/BasePolicy.js';

export default class GradebookGradePolicy extends BasePolicy {
    view(user, gradebookGrade, course) {
        return user.hasPermissionViaCourseTo(course, 'view a grade');
    }

    create(user, groupIds) {
        if (!groupIds) {
            return user.hasPermissionTo('create a grade');
        }

        return user.hasGroupPermissionTo('create a grade');
    }

    update(user, gradebookGrade, course) {
        return user.hasPermissionViaCourseTo(course, 'edit a grade');
    }

    delete(user, gradebookGrade, course) {
        return user.hasPermissionViaCourseTo(course, 'delete a grade');
    }
}
